import { Box, FormControlLabel, Grid, styled } from '@mui/material';
import { FIXED_FOOTER_HEIGHT } from 'src/constants';
import { theme } from 'src/utils';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Wrapper = styled(Box)`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow-y: auto;
  height: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  gap: 8px;
  > * {
    width: calc(33% - 8px);
  }
  max-height: calc(78vh - ${FIXED_FOOTER_HEIGHT}px);
`;

export const LocationWrapper = styled(Box)`
  flex-direction: column;
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: end;
  gap: 20px;
  margin: 32px 16px;
`;

export const EmptyLocation = styled(Box)`
  padding: 10px 300px;
  color: ${theme.status.danger.dark};
  background-color: ${theme.status.danger.light};
  margin-top: 30px;
  font-family: Roboto;
  font-weight: 300;
  width: 100%;
`;

export const NoResultContainer = styled(Box)`
  width: 100%;
`;

export const TableContainer = styled(Box)(({ theme }) => ({
  marginTop: 20,
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: 10,
  overflow: 'hidden',
  height: '68vh',
  overflowY: 'auto',
}));

export const TableHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: '8px 10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

export const TableGrid = styled(Grid)(() => ({
  margin: 0,
  alignContent: 'flex-start',
  minHeight: 'inherit',
}));

export const TableCheckboxLabel = styled(FormControlLabel)`
  font-size: 16px;
  font-weight: 300;
  font-family: 'Roboto';
  max-width: 100%;
`;

export const TruncatedText = styled('span')`
  display: inline-block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
`;
